<template>
	<div class="container-configuration-reserves-permissions">
		<ui-card-toggle
			design="brightness"
            set-status
            :open="true"
		>
			<template #title>
				<div class="title-permissions">
					<em class="fal fa-key" />

                    <span>Permissões</span>
                </div>
            </template>

			<template #content>
				<div class="area-card">
					<transition name="small-fade">
						<div v-show="loader.body" class="loading-card">
							<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
						</div>
					</transition>

					<div class="internal-header">
						<h2 class="title">Filas de Reservas</h2>
						<span class="desc">
							Quais perfis poderão ignorar a ordem da fila de reservas.
						</span>
					</div>

					<ui-select-2
						v-model="form.configsQueueReserves"
						:data="userGroups"
						:search="false"
						item-label="label"
						multiple
					/>
				</div>

                <div class="footer-card">
                    <ui-button
                        design="md success"
                        :disabled="!canSubmit"
                        @click="submit"
                    >
						<span v-if="loader.overlay" class="loading-submit-teams">
                            <ui-load-indicator bg-color="#fff" color="#41A870" :h="20" :stroke="6" />
                        </span>
                        Salvar
                    </ui-button>
                </div>
			</template>
		</ui-card-toggle>

		<ui-toogle-transfer-reserves />
	</div>
</template>
<script>
	import { uiLoadIndicator } from '@/components/ui'
	import { uiToogleTransferReserves } from '@/components/ui-facilita/configurations'
	import { uiButton } from '@/components/ui/buttons'
	import { uiCardToggle } from '@/components/ui/cards'
	import { uiSelect2 } from '@/components/ui/form'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { alertMixin, formMixin, utilMixin } from '@/mixins'
	import { getConfig, saveConfig } from '../../util/methods'

	import { defaultOptionsUserGroups, selectUserList } from '../../util/functions'

	const userGroups = ['admin', 'collaborator', 'supervisor', 'manager']

	const defaultForm = () => ({
		configsQueueReserves: null,
	})

	const defaultDisabled = () => ({})

	const defaultChecked = () => ({
		ownerDuplicate: false,
	})

	const defaultLoader = () => ({
		body: false,
		overlay: false
	})

	export default {
		name: 'configuration-reserves-permissions',

		components: {
			uiCardToggle,
			uiButton,
			uiSelect2,
			uiLoadSuccess,
			uiLoadIndicator,
			uiToogleTransferReserves
		},

		mixins: [utilMixin, formMixin, alertMixin],

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				checked: { ...defaultChecked() },
				userGroups: [...defaultOptionsUserGroups(userGroups)],
				loader: { ...defaultLoader() },
				oldForm: {},
			}
		},

		async created() {
			this.loader.body = true

			const configsQueueReserves = await this.getConfig('configsQueueReserves', 'value_long')
			this.form.configsQueueReserves = [
				...selectUserList(configsQueueReserves.required, userGroups),
			]

			this.loader.body = false
			this.$mx_copyOldForm()
		},

		computed: {
			canSubmit() {
				return this.$mx_isFormChanged && !this.loader.body
			},

			configsQueueReservesData() {
				let required = []
				this.form.configsQueueReserves.forEach((item) => {
					required.push(item.value)
				})
				return {
					required,
				}
			},
		},

		methods: {
			getConfig,
			saveConfig,

			async submit() {
				try {
					this.loader.overlay = true

					const response = await this.saveConfig(
						'configsQueueReserves',
						this.configsQueueReservesData,
						'value_long',
					)
                    this.$mx_alertSuccess(response.data.msg)
					this.$mx_copyOldForm()
				} catch (error) {
					this.$mx_alertThisOnError(error)
				} finally {
					this.loader.overlay = false
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
